// Angular imports
import { HttpClient } from '@angular/common/http';
// 3rd party imports
import { plainToClass } from 'class-transformer';
import { map } from 'rxjs/operators';
// service imports
import { MPCacheRegistrationService } from '../../_services/shared-services/mp-cache-registration-service';
import { AAPUserMetricsResultDto } from '../_models/workflow-user-metrics/aap-user-metrics-result-dto';
import { AAPUserResultDto } from '../_models/workflow-user-metrics/aap-user-result-dto';
// constant imports
import { URLConstants } from '../../_constants/url-constants';
import { CacheDuration } from '../../_constants/cache-duration';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../_services/shared-services/mp-cache-registration-service";
export class WorkflowUserMetricsService {
    constructor(httpClient, cacheRegistrationService) {
        this.httpClient = httpClient;
        this.cacheRegistrationService = cacheRegistrationService;
    }
    getAAPUser() {
        const url = `${URLConstants.ccWorkflowViewerBaseApiUrl}metrics/user`;
        this.cacheRegistrationService.registerForCache(url, true);
        const headers = this.cacheRegistrationService.getHttpRequestHeaders(url, CacheDuration.fifteenMinute);
        const options = { headers };
        return this.httpClient
            .get(url, options)
            .pipe(map((response) => plainToClass(AAPUserResultDto, response)));
    }
    getUserMetrics(baseParams) {
        const url = `${URLConstants.ccWorkflowViewerBaseApiUrl}metrics${baseParams.getQueryString()}`;
        this.cacheRegistrationService.registerForCache(url, true);
        const headers = this.cacheRegistrationService.getHttpRequestHeaders(url, CacheDuration.fifteenMinute);
        const options = { headers };
        return this.httpClient
            .get(url, options)
            .pipe(map((response) => plainToClass(AAPUserMetricsResultDto, response)));
    }
}
WorkflowUserMetricsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function WorkflowUserMetricsService_Factory() { return new WorkflowUserMetricsService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.MPCacheRegistrationService)); }, token: WorkflowUserMetricsService, providedIn: "root" });
